'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isActiveParcel = function isActiveParcel(parcel) {
  return parcel.quantity !== 0;
};

var parcelsAdapter = function parcelsAdapter(parcels) {
  return parcels.filter(isActiveParcel);
};

exports.default = parcelsAdapter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/adapters/parcelsAdapter.js
// module id = 481
// module chunks = 3 4 5